'use client'
/**
 * Écran d'erreur autonome, en français, sans feuille de style externe :
 * utilisé quand l'erreur survient AVANT que le layout de la page (menu,
 * styles) ait pu s'afficher — panne de la base pendant la lecture de la
 * session, par exemple. Sert à global-error.tsx et à (espace)/error.tsx.
 */
import { useEffect } from 'react'

const VERT = '#1B4D3E'

export default function ErreurAutonome({
  error,
  reset,
  retour,
}: {
  error: Error & { digest?: string }
  reset: () => void
  retour?: { href: string; libelle: string }
}) {
  useEffect(() => {
    console.error('Erreur :', error)
  }, [error])

  // L'erreur vient le plus souvent du serveur (layout, session) : reset()
  // seul re-rendrait le même résultat. Un rechargement relance la requête.
  const reessayer = () => {
    if (typeof window !== 'undefined') window.location.reload()
    else reset()
  }

  return (
    <div
      role="alert"
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 16px',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
        color: '#1F2937',
      }}
    >
      <div style={{ maxWidth: 440, textAlign: 'center' }}>
        <p style={{ fontSize: 20, fontWeight: 700, margin: '0 0 12px', color: VERT }}>
          Cette page n’a pas pu s’afficher.
        </p>
        <p style={{ fontSize: 16, lineHeight: 1.55, margin: '0 0 24px', color: '#4B5563' }}>
          Le service est momentanément indisponible. Réessayez dans un instant. Si le problème persiste, écrivez-nous à{' '}
          <a href="mailto:contact@stock-co2.fr" style={{ color: VERT }}>contact@stock-co2.fr</a>
          {error.digest ? ` (référence ${error.digest})` : ''}.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={reessayer}
            style={{
              minHeight: 44,
              padding: '0 22px',
              borderRadius: 10,
              border: 'none',
              background: VERT,
              color: '#fff',
              fontSize: 16,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Réessayer
          </button>
          {retour && (
            <a
              href={retour.href}
              style={{
                minHeight: 44,
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0 22px',
                borderRadius: 10,
                border: `1px solid ${VERT}`,
                color: VERT,
                fontSize: 16,
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              {retour.libelle}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
